export default "__VITE_ASSET__0xFrBP2sToTV9Q0V6r2CxQ__"